export const normalizeBonusSystemWager = ({
  wageredPercent,
  wageredAmount,
  amountForWager,
  campaignId,
  campaignName,
  currency
}) => ({
  name: campaignName,
  campaignId,
  outputMaxTotal: amountForWager,
  outputBetTotal: wageredAmount,
  wageredPercent,
  bonusCurrency: currency
});
